import React from "react";
import Footer from "./Footer";

function ContactUs() {
  return (
    <div>
      {/* Full-width Hero Image Section */}
      <div className="relative w-full m-h-screen mt-0">
          <img
            src="/Hero-ContactUs.jpeg"
            // className="w-full h-[70vh] object-cover"
            // className="w-full object-cover object-center h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] xl:h-[85vh]"
            // className="w-full object-cover object-center h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] xl:h-[85vh]"
            // className="w-full object-cover object-center h-[45vh] sm:h-[55vh] md:h-[65vh] lg:h-[75vh] xl:h-[85vh]"
            className="w-full h-auto object-cover object-center"

          />
          <div className="absolute inset-x-0 bottom-0 sm:bottom-4 left-0 right-0 text-white text-center px-6 sm:px-12">
            <div className="bg-black bg-opacity-50 p-2 sm:p-6 rounded-lg inline-block">
              <h1 className="text-xl sm:text-5xl font-bold drop-shadow-lg">Contact Us</h1>
            </div>
          </div>
        </div>
      <div className="max-w-3xl mx-auto p-8 mt-10 bg-gradient-to-b from-gray-50 to-gray-100 shadow-2xl rounded-xl border border-gray-300 text-gray-800 mb-8">
        
        {/* Media Enquiries Section */}
        {/* <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-300"> */}
        <div className="bg-white p-6 rounded-xl shadow-xl border border-primary">
          <h2 className="text-4xl font-bold text-primary text-center mb-4">Media Enquiries</h2>
          <p className="text-lg text-center text-gray-600 mb-6">
            For media-related inquiries, please contact:
          </p>
          <div className="bg-gray-50 p-6 rounded-xl shadow-md text-center border border-gray-200">
            <h3 className="text-2xl font-semibold text-gray-900">Jeff Renaud</h3>
            <p className="text-lg text-gray-700">Media Relations Consultant</p>
            <p className="text-lg text-gray-700">Western University</p>
            <p className="text-lg text-gray-900 font-semibold mt-2 border-t border-gray-300 pt-2">519-520-7281</p>
          </div>
        </div>

        {/* Divider with Accent Line */}
        <div className="relative my-10">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center">
            <span className="bg-gray-100 px-4 text-gray-600 text-sm uppercase tracking-wide">OR</span>
          </div>
        </div>

        {/* All Other Enquiries Section */}
        {/* <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-300"> */}
        <div className="bg-white p-6 rounded-xl shadow-xl border border-primary">
          <h2 className="text-4xl font-bold text-primary text-center mb-4">All Other Enquiries</h2>
          <p className="text-lg text-center text-gray-600 mb-6">
            For general inquiries, please contact:
          </p>
          <div className="bg-gray-50 p-6 rounded-xl shadow-md text-center border border-gray-200">
            <h3 className="text-2xl font-semibold text-gray-900">The Owen Lab</h3>
            <p className="text-lg text-gray-700">Western University</p>
            <p className="text-lg text-gray-900 font-semibold mt-2 border-t border-gray-300 pt-2">OwenLab@uwo.ca</p>
          </div>
        </div>
      </div>

      {/* Full Height Image Underneath Content
      <div className="absolute inset-x-0 bottom-0 w-full h-96 bg-cover bg-center" style={{ backgroundImage: "url('/Adrian_Machine.jpg')" }}></div> */}
      <Footer isFullFooter={false} />
    </div>
  );
}

export default ContactUs;



